// src/components/LogViewer/LogViewer.js
import React, { useState, useEffect, useRef } from 'react';
import { Paper, Typography } from '@mui/material';

function LogViewer() {
    const [logs, setLogs] = useState([]);
    const wsRef = useRef(null);
    const logContainerRef = useRef(null);

    // Auto-scroll function
    const scrollToBottom = () => {
        if (logContainerRef.current) {
            logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        wsRef.current = new WebSocket('wss://argus.wpappdev.com/ws');
        
        wsRef.current.onmessage = (event) => {
            setLogs(prev => [...prev, event.data]);
            // Schedule scroll after state update
            setTimeout(scrollToBottom, 0);
        };

        wsRef.current.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        return () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
        };
    }, []);

    return (
        <Paper elevation={3} sx={{ p: 2, m: 2 }}>
            <Typography variant="h6" gutterBottom>
                Current Log
            </Typography>
            <Paper 
                ref={logContainerRef}
                elevation={1} 
                sx={{ 
                    bgcolor: '#1e1e1e',
                    color: '#fff',
                    p: 2,
                    height: '600px',
                    overflow: 'auto',
                    fontFamily: 'monospace',
                    whiteSpace: 'pre-wrap'
                }}
            >
                {logs.map((line, index) => (
                    <div key={index}>{line}</div>
                ))}
            </Paper>
        </Paper>
    );
}

export default LogViewer;